module.exports = __webpack_public_path__ + "img/icn_check_roller.5aff87fd.png";